import React from 'react';
import PropTypes from 'prop-types';
import { useTrapFocus } from '@weahead/react-customizable-modal';
import CategoryItem from "./CategoryItem";
import * as CategoriesUI from "./Categories.styles";
var CATEGORY_LEVELS_THRESHOLD = 1;

function Categories(_ref) {
  var categories = _ref.categories,
      _ref$onCategoryClick = _ref.onCategoryClick,
      onCategoryClick = _ref$onCategoryClick === void 0 ? function () {} : _ref$onCategoryClick,
      linkComponent = _ref.linkComponent,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth;
  return /*#__PURE__*/React.createElement(React.Fragment, null, categories.map(function (_ref2) {
    var items = _ref2.items,
        label = _ref2.label,
        value = _ref2.value,
        _ref2$url = _ref2.url,
        url = _ref2$url === void 0 ? '' : _ref2$url,
        labelExtra = _ref2.labelExtra,
        external = _ref2.external,
        sponsored = _ref2.sponsored;
    return items.length > 0 && depth < CATEGORY_LEVELS_THRESHOLD ? /*#__PURE__*/React.createElement(CategoriesUI.ListItem, {
      key: value
    }, /*#__PURE__*/React.createElement(CategoryItem, {
      label: label,
      labelExtra: labelExtra,
      linkComponent: linkComponent,
      href: url,
      depth: depth,
      onCategoryClick: onCategoryClick,
      external: external,
      sponsored: sponsored
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(Categories, {
      categories: items,
      onCategoryClick: onCategoryClick,
      linkComponent: linkComponent,
      depth: depth + 1
    }))) : /*#__PURE__*/React.createElement("li", {
      key: value
    }, /*#__PURE__*/React.createElement(CategoryItem, {
      label: label,
      labelExtra: labelExtra,
      linkComponent: linkComponent,
      href: url,
      depth: depth,
      onCategoryClick: onCategoryClick,
      external: external,
      sponsored: sponsored
    }));
  }));
}

Categories.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.array.isRequired,
  linkComponent: PropTypes.node,
  depth: PropTypes.number,
  onCategoryClick: PropTypes.func
} : {};

function CategoriesContainer(_ref3) {
  var categories = _ref3.categories,
      _ref3$onCategoryClick = _ref3.onCategoryClick,
      onCategoryClick = _ref3$onCategoryClick === void 0 ? function () {} : _ref3$onCategoryClick,
      linkComponent = _ref3.linkComponent;
  var focusRef = useTrapFocus();
  return /*#__PURE__*/React.createElement(CategoriesUI.Container, {
    ref: focusRef
  }, /*#__PURE__*/React.createElement(CategoriesUI.List, null, /*#__PURE__*/React.createElement(Categories, {
    categories: categories,
    onCategoryClick: onCategoryClick,
    linkComponent: linkComponent
  })));
}

CategoriesContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.array.isRequired,
  linkComponent: PropTypes.node,
  onCategoryClick: PropTypes.func
} : {};
export default CategoriesContainer;
//# sourceMappingURL=Categories.js.map